import React from 'react';
import PropTypes from 'prop-types';

import { ErrorMessage, ContainerError } from './questions/styles';

const Error = (props) => {
  const {
    index,
    errors,
    touched,
    uploadError,
  } = props;

  if (uploadError) {
    return (
      <ContainerError>
        <ErrorMessage>{uploadError}</ErrorMessage>
      </ContainerError>
    );
  }

  if (!errors) return null;

  const { tasks } = errors;
  const { tasks: touchedTasks = [] } = touched;

  if (!tasks) return null;

  const error = tasks[index] || {};
  const { label: touchedTask = false } = touchedTasks[index] || {};

  if (error.imageKey || error.videoKey) {
    return (<ErrorMessage>{error.imageKey || error.videoKey}</ErrorMessage>);
  }

  if (error.label && touchedTask) {
    return (<ErrorMessage>{error.label}</ErrorMessage>);
  }

  return null;
};

Error.propTypes = {
  index: PropTypes.number.isRequired,
  errors: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape()),
    PropTypes.shape(),
  ]).isRequired,
  touched: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape()),
    PropTypes.shape(),
  ]).isRequired,
  uploadError: PropTypes.string,
};

Error.defaultProps = {
  uploadError: '',
};

export default Error;
